import styles from "./ReaderModal.module.css";

type ReaderModalProps = { className?: string };

import { useI18n } from "@/contexts/i18nContext";
import Article from "@components/Article";
import Modal, { ModalContent, ModalDescription } from "@components/Modal";
import Typography from "@components/Typography";

import { useEpisode } from "../../../context";

const ReaderModal: React.FunctionComponent<ReaderModalProps> = ({
  ...props
}) => {
  const { published_date, show, title, article_text, cover } = useEpisode();
  const { formatDate } = useI18n();

  return (
    <Modal {...props} className={styles.modal} data-testid="reader-modal">
      <ModalDescription>
        {show}, {formatDate(new Date(published_date), "PPPP")}
      </ModalDescription>
      <ModalContent>
        <Typography variant="h3">{title}</Typography>
        <div className={styles.wrapper}>
          {cover && <img src={cover} width="100%" />}
          {/** We know it's set here - SHould be typed better to assure this higher up in the hierarchy */}
          <Article {...props} content={article_text as string} />
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ReaderModal;
